import React from "react";
import { useTranslation } from "react-i18next";
import consentTexts from "../content/legal/consent-texts.json";
import "../styles/components/FeatureConsentModal.css";

export default function FeatureConsentModal({
  consentKey,
  title,
  isOpen,
  isSubmitting = false,
  error = "",
  onAccept,
  onCancel,
}) {
  const { t } = useTranslation();
  const consentContent = consentTexts[consentKey];

  if (!isOpen || !consentContent) {
    return null;
  }

  return (
    <div className="feature-consent-overlay" role="presentation">
      <div
        className="feature-consent-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={`feature-consent-title-${consentKey}`}
      >
        <p className="feature-consent-eyebrow">{t("feature_consent_required")}</p>
        <h3
          id={`feature-consent-title-${consentKey}`}
          className="feature-consent-title"
        >
          {title}
        </h3>

        <p className="feature-consent-label">{consentContent.label}</p>
        {consentContent.helper ? (
          <p className="feature-consent-helper">{consentContent.helper}</p>
        ) : null}
        {consentContent.warning ? (
          <p className="feature-consent-warning">{consentContent.warning}</p>
        ) : null}
        {consentContent.tooltip ? (
          <p className="feature-consent-tooltip">{consentContent.tooltip}</p>
        ) : null}
        {error ? <p className="feature-consent-error">{error}</p> : null}

        <div className="feature-consent-actions">
          <button
            type="button"
            className="feature-consent-button feature-consent-button-secondary"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            {t("cancel")}
          </button>
          <button
            type="button"
            className="feature-consent-button"
            onClick={onAccept}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("feature_consent_saving") : t("feature_consent_continue")}
          </button>
        </div>
      </div>
    </div>
  );
}
